
import Vue from "vue";
export default Vue.extend({
	data() {
		return {
			activatorRect: undefined as undefined | ClientRect,
			updatingRect: false
		};
	},

	props: {
		x: Number,
		y: Number,
		up: Boolean,
		closeOnBlur: Boolean,
		closeOnClick: Boolean,
		width: String,
		right: Boolean,
		dontCloseOnClick: Boolean,
		value: Boolean,
		autoUp: Boolean
	},

	computed: {
		topPos():string | undefined {
			if (this.isUp) return undefined;
			if (this.y) return `${this.y}px`;
			if (!this.activatorRect) return undefined;
			return `${this.activatorRect.bottom}px`;
		},
		bottomPos():string | undefined {
			if (!this.isUp) return undefined;
			if (this.y) {
				if (this.autoUp) {
					return `${window.innerHeight - this.y}px`;
				}
				return `${this.y}px`;
			}
			if (!this.activatorRect) return undefined;
			return `${window.innerHeight - this.activatorRect.top}px`;
		},
		leftPos():string | undefined {
			if (this.right) return undefined;
			if (this.x) return `${this.x}px`;
			if (!this.activatorRect) return undefined;
			return `${this.activatorRect.left}px`;
		},
		rightPos():string | undefined {
			if (!this.right) return undefined;
			if (this.x) return `${this.x}px`;
			if (!this.activatorRect) return undefined;
			return `${window.innerWidth - this.activatorRect.right}px`;
		},
		widthPos():string | undefined {
			if (this.width) {
				return this.width;
			}
			if (!this.activatorRect) return undefined;
			return `${this.activatorRect.width}px`;
		},
		isUp():boolean {
			if (!this.autoUp) {
				return this.up;
			}
			if (this.y > window.innerHeight / 2) {
				return true;
			}
			return false;
		}
	},

	watch: {
		value(val:boolean) {
			if(val) {
				requestAnimationFrame(this.updateActivatorRect);
			}
		}
	},

	methods: {
		toggle() {
			if (this.value) {
				this.close();
			} else {
				this.open();
			}
		},
		close() {
			this.$emit("input", false);
		},
		open() {
			this.$emit("input", true);
		},
		updateActivatorRect() {
			if (this.updatingRect) return;
			this.updatingRect = true;
			requestAnimationFrame(() => this.updatingRect = false);
			if (!this.value) return;
			let activators = this.$slots.activator;
			if (!activators) return;
			let activator = activators[0];
			if (!activator) return;
			let el = activator.elm;
			if (!el) return;
			let rect = (el as HTMLElement).getBoundingClientRect();
			if (!rect) return;
			this.activatorRect = rect;
		},
		onBlur() {
			setTimeout(() => {
				if (this.$el.contains(document.activeElement)) {
					return;
				}
				this.$emit("blur");
				if (!this.closeOnBlur) return;
				this.close();
			}, 100);
		},
		onFocus() {
			this.$emit("focus");
		}
	},

	mounted() {
		let activators = this.$slots.activator;
		if (!activators) return;
		let activator = activators[0];
		if (!activator) return;
		let el = activator.elm as HTMLElement | null;
		if (!el) return;
		el.addEventListener("click", this.toggle);
		window.addEventListener("resize", this.updateActivatorRect);
		el = this.$el as HTMLElement;
		while (el) {
			el.addEventListener("scroll", this.updateActivatorRect);
			el = el.parentElement;
		}
	},

	destroyed() {
		window.removeEventListener("resize", this.updateActivatorRect);

		let activators = this.$slots.activator;
		if (!activators) return;
		let activator = activators[0];
		if (!activator) return;
		let el = activator.elm as HTMLElement | null;
		if (!el) return;
		while (el) {
			el.removeEventListener("scroll", this.updateActivatorRect);
			el = el.parentElement;
		}
	}
});
